module.exports = __webpack_public_path__ + "img/dropsSlots_1920.ed104602.png";